__turbopack_context__.v({
  "body": "checkbox-module__se8Y7G__body",
  "description": "checkbox-module__se8Y7G__description",
  "error": "checkbox-module__se8Y7G__error",
  "icon": "checkbox-module__se8Y7G__icon",
  "inner": "checkbox-module__se8Y7G__inner",
  "innerError": "checkbox-module__se8Y7G__innerError",
  "input": "checkbox-module__se8Y7G__input",
  "label": "checkbox-module__se8Y7G__label",
  "labelWrapper": "checkbox-module__se8Y7G__labelWrapper",
  "loading": "checkbox-module__se8Y7G__loading",
  "loadingBox": "checkbox-module__se8Y7G__loadingBox",
  "loadingLabel": "checkbox-module__se8Y7G__loadingLabel",
  "root": "checkbox-module__se8Y7G__root",
  "rootDisabled": "checkbox-module__se8Y7G__rootDisabled",
});
